<template>
  <div class="become-container mt-5">

    <!-- Close / Back Arrow -->
    <!--div
      class="close-btn"
      role="button"
      aria-label="Fermer"
      @click="close"
    >
      <i class="fas fa-arrow-left"></i>
    </div-->

    <div class="become-card">

      <!-- Title -->
      <h1 class="become-title text-dark mb-4">Devenir adhérent</h1>

      <!-- Stepper -->
      <div class="stepper">
        <span
          v-for="n in 3"
          :key="n"
          class="step"
          :class="{ active: n <= step }"
        ></span>
      </div>

      <!-- Step title -->
      <div class="steps-text mt-4 pt-2 mb-5">
        <p class="active-step text-primary font-weight-bold">
          {{ stepTitle }}
        </p>
      </div>

      <!-- FORM -->
      <b-form @submit.prevent="nextStep" class="text-left">

        <!-- STEP 1 -->
        <template v-if="step === 1">
          <b-form-group label="Nom de la pharmacie" class="text-dark">
            <b-form-input v-model="form.companyName" class="become-input" required />
          </b-form-group>

           <b-form-group label="Ville" class="text-dark">
            <b-form-input v-model="form.city" class="become-input " required />
          </b-form-group>

          <b-form-group label="Adresse" class="text-dark">
            <b-form-input v-model="form.address" class="become-input" required />
          </b-form-group>

        </template>

        <!-- STEP 2 -->
        <template v-if="step === 2">
          <b-form-group label="Nom & Prénom" class="text-dark">
            <b-form-input v-model="form.fullName" class="become-input" required />
          </b-form-group>

          <b-form-group label="Téléphone" class="text-dark">
            <b-form-input
              v-model="form.phone"
              class="become-input"
              type="tel"
              pattern="^\+?[0-9\s\-]+$"
              required
            />
          </b-form-group>


          <b-form-group label="Email" class="text-dark">
            <b-form-input type="email" v-model="form.email" class="become-input" required />
          </b-form-group>
        </template>

        <!-- STEP 3 -->
        <template v-if="step === 3">
          <div class="recap-section text-dark">

            <h5 class="mb-3 text-uppercase font-weight-bold">Informations Pharmacie</h5>
            <p><strong>Nom :</strong> {{ form.companyName }}</p>
            <p><strong>Adresse :</strong> {{ form.address }}</p>
            <p><strong>Ville :</strong> {{ form.city }}</p>


            <h5 class="mb-3 text-uppercase font-weight-bold mt-5">Informations Pharmacien</h5>
            <p><strong>Nom :</strong> {{ form.fullName }}</p>
            <p><strong>Téléphone :</strong> {{ form.phone }}</p>
            <p><strong>Email :</strong> {{ form.email }}</p>

          </div>
        </template>

      <!-- Buttons -->
      <div class="d-flex mt-4">

        <!-- :class="step === 1 ? 'invisible' : ''"  :disabled="step === 1" -->
        <b-button
          variant="outline-light"
          class="become-cancel-btn w-100 mr-2 mt-4"
          
          @click.prevent="prevStep"
        >
          Retour
        </b-button>

        <b-button type="submit" variant="success" class="btn-continue ml-2 mt-4" block>
          {{ submitLabel }}
        </b-button>

      </div>

      </b-form>
    </div>
  </div>
</template>

<script>
import UsersApi from "@/services/users-api";
export default {
  name: "BecomeMember",

  data() {
    return {
      step: 1,
      form: {
        companyName: '',
        address: '',
        city: '',
        fullName: '',
        phone: '',
        email: '',
      },
    };
  },

  computed: {
    submitLabel() {
      return this.step < 3 ? 'Continuer' : 'Envoyer';
    },
    stepTitle() {
      switch (this.step) {
        case 1: return 'Informations Pharmacie';
        case 2: return 'Informations Pharmacien';
        case 3: return 'Valider la demande de contact';
        default: return '';
      }
    },
  },

  methods: {

    close() {
      this.$emit("closeBecomeMember");
    },

    nextStep() {
      if (this.step < 3) {
        this.step++;
      } else {
        this.sendBecomeMember()
      }
    },

    sendBecomeMember(){
      UsersApi.sendBecomeMember(this.form).then((result) =>{
          if(result){
            this.close()
          }
        }
      )
    },

    prevStep() {
      if (this.step > 1) {
        this.step--;
      } else {
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.become-container {
  position: relative;
}

/* Close arrow */
/*.close-btn {
  position: absolute;
  top: 20px;
  left: 20px;
  font-size: 22px;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.close-btn:hover {
  transform: translateX(-4px);
  opacity: 0.8;
}*/

/* Buttons */
.become-cancel-btn {
  height: 45px;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 600;
}

.btn-continue {
  height: 45px;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 600;
  border: none;
}

/* Card */
.become-card {
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
}

.become-title {
  font-size: 38px;
  font-weight: 700;
}

/* Inputs */
.become-input {
  height: 45px;
  border-radius: 6px;
  border: 1.5px solid #ddd;
  font-size: 16px;
  padding-left: 15px;
}

/* Stepper */
.stepper {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
}

.step {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #dcdcdc;
  transition: all 0.3s ease;
}

.step.active {
  background: #297a54;
  transform: scale(1.2);
}

/* Steps text */
.steps-text {
  margin-bottom: 20px;
}

.active-step {
  font-weight: 600;
  color: #000;
}
</style>
